import { render, staticRenderFns } from "./Webcam.vue?vue&type=template&id=53fca80a&scoped=true"
import script from "./Webcam.vue?vue&type=script&lang=js"
export * from "./Webcam.vue?vue&type=script&lang=js"
import style0 from "./Webcam.vue?vue&type=style&index=0&id=53fca80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fca80a",
  null
  
)

export default component.exports